import React from 'react';
import { useTranslation } from 'react-i18next';
import { Dropdown, Label, Option } from '@fluentui/react-components';
import { CustomerNotificationStatus } from '../../../store/features/departureBoard/departureBoardSlice';

interface CustomerNotificationProps {
    label: string;
    value: CustomerNotificationStatus | '';
    onValueChange: (status: CustomerNotificationStatus) => void;
}

export const CustomerNotificationFilter: React.FC<CustomerNotificationProps> = ({
    label,
    value,
    onValueChange,
}) => {
    const { t } = useTranslation();

    return (
        <>
            <Label>{label}</Label>
            <Dropdown
                selectedOptions={value ? [value] : []}
                value={value ? t(`CustomerNotificationStatus_${value}`) : undefined}
                onOptionSelect={(_, data) => {
                    if (data.optionValue) {
                        onValueChange(data.optionValue as CustomerNotificationStatus);
                    }
                }}
            >
                <Option
                    key="option_not_available"
                    text={t('CustomerNotificationStatus_NotAvailable')!}
                    value={CustomerNotificationStatus.NotAvailable}
                >
                    {t('CustomerNotificationStatus_NotAvailable')}
                </Option>
                <Option
                    key="option_outstanding_actions"
                    text={t('CustomerNotificationStatus_OutstandingActions')!}
                    value={CustomerNotificationStatus.OutstandingActions}
                >
                    {t('CustomerNotificationStatus_OutstandingActions')}
                </Option>
                <Option
                    key="option_all_notified"
                    text={t('CustomerNotificationStatus_AllNotified')!}
                    value={CustomerNotificationStatus.AllNotified}
                >
                    {t('CustomerNotificationStatus_AllNotified')}
                </Option>
            </Dropdown>
        </>
    );
};
